import { parse } from 'date-fns';

const parseFrenchDate = (stringDate) => parse(stringDate, 'dd/MM/yyyy', new Date());

export default parseFrenchDate;
